/* eslint-disable react/function-component-definition */
import { Checkbox, Form, Input } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { InputProps } from 'antd/lib/input';
import React, { ReactNode } from 'react';
import { useDisplayFrameworkContext } from '../hooks/useDisplayFrameworkContext';

export type DisplayFrameworkInputProps<P> = FormItemProps & {
  /**
   * Component identifier. Must be unique per page.
   * If omited, `name` will be used as comcode.
   */
  comcode?: string;
  component?: React.ComponentType<P>;
  componentProps?: P;
  required?: string | boolean;
  children?: ReactNode;
};

const DisplayFrameworkInput = function <P = InputProps>(
  props: DisplayFrameworkInputProps<P>
) {
  const {
    componentProps,
    component,
    comcode: comcodProp,
    name,
    rules: rulesProp = [],
    required,
    style,
    normalize,
    children,
  } = props;

  const Component = component ?? Input;

  const itemExtraProps: any = {};

  if (Component === Checkbox) {
    itemExtraProps.valuePropName = 'checked';
  }

  const {
    getComponentConfiguration,
    getComponentLabel,
  } = useDisplayFrameworkContext();
  const comcode = comcodProp ?? (name as string);
  const componentConfiguration = getComponentConfiguration(comcode);

  const label = getComponentLabel(comcode);
  const placeholder = componentConfiguration?.complaceholder ?? undefined;
  const title = componentConfiguration?.comhint;

  const rules = rulesProp;

  if (required === true) {
    rules.push({ required: true, message: 'This field is required' });
  } else if (typeof required === 'string') {
    rules.push({ required: true, message: required });
  }

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      style={style}
      normalize={normalize}
      {...itemExtraProps}
    >
      {children ? (
        children
      ) : (
        <Component
          {...(componentProps as P)}
          placeholder={placeholder}
          title={title}
        />
      )}
    </Form.Item>
  );
};

export default DisplayFrameworkInput;
